import React from "react";
import { iconProps } from "../../../../Helper";

export const BgRemoverIcon = ({ className }: iconProps) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="0.5"
        width="15"
        height="15"
        stroke="white"
        strokeDasharray="2 2"
        className={className}
      />

      <rect x="5" y="4.5" width="7" height="7" className={className} />
      <line
        x1="9.85355"
        y1="4.35355"
        x2="4.85355"
        y2="9.35355"
        className={className}
      />
      <line
        x1="11.8536"
        y1="5.35355"
        x2="5.85355"
        y2="11.3536"
        className={className}
      />
      <line
        x1="11.8536"
        y1="8.35355"
        x2="8.85355"
        y2="11.3536"
        className={className}
      />
    </svg>
  );
};
